'use strict';

import angular from 'angular';
import template from './modal.pug';

const GrpRoleModalSvc = [
  'ModalSvc',
  'ToastrSvc',
  'GrpRoleTypeSvc',
  'GrpRoleSvc',
  function(
    ModalSvc,
    ToastrSvc,
    GrpRoleTypeSvc,
    GrpRoleSvc
  ) {
    var roleIcon = {
      0: 'fa fa-lock kinda-red',
      1: 'fa fa-eye light-blue',
      2: 'fa fa-check green'
    };

    var fullAdmin = {
      value: {name: 'Full Admin', identifier: 'fullAdmin'},
      group: {
        summary: roleIcon[2],
        info: roleIcon[2],
        members: roleIcon[2],
        settings: roleIcon[2],
        payments: roleIcon[2],
      },
      user: {
        personal: roleIcon[2],
        contact: roleIcon[2],
        member: roleIcon[2],
        payment: roleIcon[2],
        type: roleIcon[2],
        position: roleIcon[2],
        technical: roleIcon[2],
      }
    };

    var admin = {
      value: {name: 'Admin', identifier: 'admin'},
      group: {
        summary: roleIcon[2],
        info: roleIcon[2],
        members: roleIcon[2],
        settings: roleIcon[2],
        payments: roleIcon[2],
      },
      user: {
        personal: roleIcon[2],
        contact: roleIcon[2],
        member: roleIcon[2],
        type: roleIcon[2],
        position: roleIcon[2],
        payment: roleIcon[2],
        technical: roleIcon[1],
      }
    };

    var adminView = {
      value: {name: 'Admin (View Only)', identifier: 'adminView'},
      group: {
        summary: roleIcon[1],
        info: roleIcon[1],
        members: roleIcon[1],
        settings: roleIcon[1],
        payments: roleIcon[1],
      },
      user: {
        personal: roleIcon[1],
        contact: roleIcon[1],
        member: roleIcon[1],
        payment: roleIcon[1],
        type: roleIcon[1],
        position: roleIcon[1],
        technical: roleIcon[1],
      }
    };

    var member = {
      value: {name: 'Member', identifier: 'member'},
      group: {
        summary: roleIcon[0],
        info: roleIcon[0],
        members: roleIcon[0],
        settings: roleIcon[0],
        payments: roleIcon[0],
      },
      user: {
        personal: roleIcon[0],
        contact: roleIcon[0],
        member: roleIcon[0],
        type: roleIcon[0],
        position: roleIcon[0],
        payment: roleIcon[0],
        technical: roleIcon[0],
      }
    };

    var roleDisplayHash = {fullAdmin, admin, adminView, member};
    /**
     * Opens the groupRole Modal
     * @param  {Object} currentGrpRle   - currentGrpRole
     * @return {Object}                 - the updated grpRole instance
     */
    function open(currentGrpRole, groupId, personId) {
      var grpRole = angular.copy(currentGrpRole);
      var modalInstance;
      var formvm = grpRole;

      GrpRoleTypeSvc.query({groupId}).$promise
        .then(function(types) {
          types.map(function(grt) {
          // BK: this is a total hack.
          // set types from server - linked via identifier
            if(roleDisplayHash[grt.identifier]) {
              roleDisplayHash[grt.identifier].value = grt;
              if(grpRole.type && Number(grpRole.type.id) === Number(grt.id)) {
                grpRole.type = grt;
              }
            }
            // remove default ids since no role is set for them
            if(grt.isDefault && !grpRole.type.id) {
              delete grt.id;
              grpRole.type = grt;
            }
            return grt;
          });
        });

      function onSubmit() {
        modalInstance.close();
        // check for change
        if(Number(grpRole.type.id) === Number(currentGrpRole.type.id)) {
          return modalInstance.close();
        }
        grpRole.typeId = grpRole.type.id;
        if(grpRole.type.isDefault) {
          delete grpRole.typeId;
        }
        grpRole.personId = personId;
        // identifier set to type name since type.id
        // is not used (and may be null)
        GrpRoleSvc.set({groupId, id: currentGrpRole.type.name}, grpRole)
          .$promise
          .then(function(res) {
            ToastrSvc.success('Role Updated');

            // if default member set - remove ID and set role
            if(grpRole.type.name === 'Member') {
              currentGrpRole.type.name = 'Member';
              return delete currentGrpRole.id;
            }

            /**
           * TODO control for single roles with groupId and personId
           */
            // append new id -  prevent dup roles
            // for group/person without refresh
            if(!currentGrpRole.id && res.id) {
              currentGrpRole.id = res.id;
            }
            angular.merge(currentGrpRole, grpRole);
          }).catch(function(e) {
            ToastrSvc.error(e.message);
          });
      }

      function onCancel() {
        modalInstance.dismiss();
      }

      var modalScope = {modalvm: {
        dismissable: true,
        definedRoles: [fullAdmin, admin, adminView, member],
        formvm,
        title: 'Edit Group Role',
        buttons: [
          {classes: 'btn-primary', text: 'Update', click: onSubmit},
          {classes: 'btn-default', text: 'Cancel', click: onCancel}
        ]
      }};

      var options = {size: 'lg', template};

      modalInstance = ModalSvc.open(modalScope, options);
      return modalInstance.result;
    }

    // Public API here
    return {
      open
    };
  }
];
export default GrpRoleModalSvc;
